import { gql } from '@apollo/client';

const getSEOGeneratedContentQuery = () => {
  const query = gql`
  query SEOGeneratedContent($nvalue: String) {
      seoGeneratedContent(nvalue: $nvalue)
  }
  `;

  return query;
};

export default getSEOGeneratedContentQuery;
